export default __webpack_public_path__ + "static/media/maxdome_more_info_small.vp9.f5a92251.webm";